import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'

import App from './App.jsx'
import PrivacyRuntime from '@components/privacy/PrivacyRuntime'
import { AuthProvider } from '@contexts/AuthContext'
import { OverlayCoordinatorProvider } from '@contexts/OverlayCoordinatorContext'
import { PrivacyPreferencesProvider } from '@contexts/PrivacyPreferencesContext'
import { ReleaseCampaignProvider } from '@contexts/ReleaseCampaignContext'
import { ThemeProvider } from '@contexts/ThemeContext'
import { initAllPerformanceOptimizations } from '@utils/performance'
import logger from '@utils/logger'
import './styles/tokens.css'
import './index.css'

// Remove browser-readable access tokens left by the pre-cookie auth client.
try {
  window.localStorage.removeItem('token')
} catch (_error) {
  // Restricted storage must not prevent the app from starting.
}

// Apply local rendering optimizations. Optional reporting is consent-gated in App.
if (import.meta.env.PROD) {
  initAllPerformanceOptimizations()
} else {
  // In development, still initialize basic monitoring
  import('@utils/performance').then(({ initPerformanceMonitoring }) => {
    initPerformanceMonitoring(metric => {
      logger.performance(metric)
    })
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ThemeProvider>
          <OverlayCoordinatorProvider>
            <PrivacyPreferencesProvider>
              <PrivacyRuntime />
              <ReleaseCampaignProvider>
                <AuthProvider>
                  <App />
                  <Toaster
                    position="top-right"
                    toastOptions={{
                      duration: 4000,
                      style: {
                        background: 'var(--x3-surface)',
                        border: '1px solid var(--x3-border)',
                        color: 'var(--x3-text)'
                      },
                      success: {
                        iconTheme: {
                          primary: '#0F9D78',
                          secondary: 'var(--x3-surface)'
                        }
                      },
                      error: {
                        iconTheme: {
                          primary: '#D94A4A',
                          secondary: 'var(--x3-surface)'
                        }
                      }
                    }}
                  />
                </AuthProvider>
              </ReleaseCampaignProvider>
            </PrivacyPreferencesProvider>
          </OverlayCoordinatorProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)
